export function definePageContextService(options) {
    const { initialPageContext, subscribe } = options;
    return {
        id: `page-context-service`,
        create: () => {
            const listeners = new Set();
            let pageContext = initialPageContext;
            subscribe((newPageContext) => {
                pageContext = newPageContext;
                for (const listener of listeners) {
                    listener(pageContext);
                }
            });
            return {
                '1.0.0': () => {
                    return {
                        featureService: {
                            getPageContext: () => pageContext,
                            subscribe: (listener) => {
                                listeners.add(listener);
                                return () => {
                                    listeners.delete(listener);
                                };
                            },
                        },
                    };
                },
            };
        },
    };
}
//# sourceMappingURL=index.js.map